import React from 'react';
import {
  faAnchor, faArrowLeft, faArrowUp, faBell, faBolt, faBook, faBookmark, faCertificate, faCheck, faChevronCircleLeft, faChevronCircleRight,
  faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faCircleCheck, faCircleQuestion, faClock,
  faCircleInfo, faClone, faComment, faCompass, faComments, faCopy, faCreditCard, faEllipsisVertical, faEye, faEyeSlash, faFlagCheckered, faFlask, faGear, faGem, faGlobe,
  faHeadphones, faHeart, faImage, faInbox, faLanguage, faLightbulb, faLink, faLock, faLockOpen, faMagnifyingGlass, faPencil, faPlay, faPlug, faPlus,
  faCamera, faCartShopping, faGift, faPaperclip, faScissors, faRightFromBracket, faRightToBracket, faRotateLeft, faRotateRight, faRss, faSpinner, faStar, faThumbtack, faToggleOff, faToggleOn, faTrashCan, faTriangleExclamation, faUnlock, faUpload, faUser, faUserPlus, faUserSecret, faUsers,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import './AppIcon.css';

const icons = {
  'arrow left': faArrowLeft,
  'arrow up': faArrowUp,
  anchor: faAnchor,
  attach: faPaperclip,
  bell: faBell,
  book: faBook,
  bookmark: faBookmark,
  camera: faCamera,
  certificate: faCertificate,
  check: faCheck,
  'check circle': faCircleCheck,
  'chevron circle left': faChevronCircleLeft,
  'chevron circle right': faChevronCircleRight,
  'chevron down': faChevronDown,
  'chevron left': faChevronLeft,
  'chevron right': faChevronRight,
  'chevron up': faChevronUp,
  'clock outline': faClock,
  circle: faCircle,
  close: faXmark,
  'comment outline': faComment,
  compass: faCompass,
  'comments outline': faComments,
  'copy outline': faCopy,
  clone: faClone,
  cut: faScissors,
  payment: faCreditCard,
  'eye slash': faEyeSlash,
  eye: faEye,
  'exclamation triangle': faTriangleExclamation,
  'ellipsis vertical': faEllipsisVertical,
  feed: faRss,
  'flag checkered': faFlagCheckered,
  gem: faGem,
  gift: faGift,
  settings: faGear,
  globe: faGlobe,
  headphones: faHeadphones,
  heart: faHeart,
  image: faImage,
  inbox: faInbox,
  lab: faFlask,
  language: faLanguage,
  lightbulb: faLightbulb,
  lightning: faBolt,
  linkify: faLink,
  lock: faLock,
  'lock open': faLockOpen,
  pencil: faPencil,
  play: faPlay,
  plug: faPlug,
  plus: faPlus,
  'question circle outline': faCircleQuestion,
  'help circle': faCircleQuestion,
  'info circle': faCircleInfo,
  'log out': faRightFromBracket,
  'sign-in': faRightToBracket,
  redo: faRotateRight,
  search: faMagnifyingGlass,
  'shopping cart': faCartShopping,
  spinner: faSpinner,
  star: faStar,
  'toggle off': faToggleOff,
  'toggle on': faToggleOn,
  thumbtack: faThumbtack,
  trash: faTrashCan,
  'trash alternate': faTrashCan,
  unlock: faUnlock,
  user: faUser,
  undo: faRotateLeft,
  upload: faUpload,
  'unlock alternate': faUnlock,
  'user secret': faUserSecret,
  'user plus': faUserPlus,
  users: faUsers
};

const sizes = {small: '0.875em', large: '1.5em'};
const colors = {olive: '#708238', red: '#b42318', green: '#25834a'};

const AppIcon = React.forwardRef(({
  name,
  size,
  color,
  loading = false,
  link = false,
  circular = false,
  bordered = false,
  disabled = false,
  onClick,
  className = '',
  style = {},
  title,
  ...props
}, ref) => {
  const definition = icons[name] || faCircleQuestion;
  const [width, height, , , paths] = definition.icon;
  const isAction = Boolean(onClick || link || disabled);
  const icon = <svg viewBox={`0 0 ${width} ${height}`} fill="currentColor"
    width="1em" height="1em" focusable="false" aria-hidden="true"
    className={`br-app-icon${loading ? ' br-app-icon--loading' : ''}`}>
    {(Array.isArray(paths) ? paths : [paths]).map((path, index) =>
      <path key={index} d={path} />)}
  </svg>;
  const rootStyle = {
    fontSize: sizes[size] || undefined,
    color: colors[color] || color,
    ...style
  };
  if (isAction) {
    return <button ref={ref} type="button" disabled={disabled}
      {...props}
      className={`br-app-icon-button${circular || bordered ? ' br-app-icon-button--bordered' : ''} ${className}`.trim()}
      style={rootStyle} onClick={onClick}
      aria-label={props['aria-label'] || title || name}
      title={title}>{icon}</button>;
  }
  return <span ref={ref} {...props} className={`br-app-icon-wrapper ${className}`.trim()}
    style={rootStyle} role={props['aria-label'] ? 'img' : undefined}
    aria-label={props['aria-label']} aria-hidden={props['aria-hidden'] ?? !props['aria-label']}
    title={title}>{icon}</span>;
});

AppIcon.displayName = 'AppIcon';
export default AppIcon;
